module.exports = Subscription;

function Subscription(json) {
	this.planId = null;
	this.planName = null;
	this.startDate = Date.now();
	this.expirationDate = null;
	this.purchaserUserId = null;
	this.userIds = [];
	this.automaticRenewal = 0; //0 or 1 (indicating true or false)
	this.isGroupSubscription = false;
	this.internalNotes = null;
	this.institutionName = null;
	this.institutionDomainName = null;
	//This field makes it possible to have the link in the upper right corner point to the library's homepage,
	//i.e. the "Welcome, [Institution Name]" link.
	this.institutionLibraryUrl = null;
	//When true, no email reminders will be sent for this subscription.
	//Assuming reminders should be sent out, just leave this undefined (or set it to null, but not to false)
	//since queries in other parts of the system assume this property is only present if reminders should be disabled.
	this.disableReminders = undefined;
	//Canceled field works similarly; leave undefined or null unless it was canceled.
	this.canceled = undefined;
	
	if (json) {
		for (var propName in json) {
			this[propName] = json[propName];
		}
	}
}

Subscription.prototype = {
	constructor: Subscription
	
  , getPurchaserAsync: function(model, cb) {
		//if no callback supplied, return a promise
		//TODO rewrite code depending on this function so that we use promise style everywhere for consistency
		var promise;
		if (!cb) {
			var resolvePromise, rejectPromise;
			promise = new Promise(function(resolve, reject) {
				resolvePromise = resolve;
				rejectPromise = reject;
			});
			cb = function(err, result) {
				if (err) {
					rejectPromise(err);
				}
				else resolvePromise(result)
			}
		}
  
		if (!this.purchaserUserId) {
			return cb(new Error('Missing purchaser ID'));
		}

		var userModel = model.at('auths.' + this.purchaserUserId);
		userModel.fetch(function(err) {
			if (err) return cb(err);
			cb(null, userModel.get());
		});
		
		return promise;
	}
	
  , getUsersAsync: function(model, cb) {
		if (!this.userIds.length) {
			return cb(null, []);
		}
		var query = model.query('auths', {id: {$in: this.userIds}, $orderby: {lastName:1}});
		query.fetch(function(err) {
			if (err) return cb(err);
			cb(null, query.get());
		});
	}

  , hasCardOnFile: function() {
        //note that (at the time of this writing)
        //the rememberCardInfo property is only set for manual renewal;
        //with automatic renewal the card info is obviously always saved
        return this.automaticRenewal || this.rememberCardInfo;
    }
	
  , getAmountPaid: function() {
		if (this.mostRecentInvoice) {
			return this.mostRecentInvoice.total / 100
		}
		else if (this.stripeCharge) {
			return this.stripeCharge.amount / 100;
		}
	}
	
  , getDatePaymentReceived: function() {
  		if (this.mostRecentInvoice && this.mostRecentInvoice.date) {
			return new Date(this.mostRecentInvoice.date * 1000);
		}
		else if (this.stripeCharge && this.stripeCharge.created) {
			return datePaymentReceived = new Date(this.stripeCharge.created * 1000);
		}
	}

  , getCouponCode: function() {
		if (this.mostRecentInvoice) {
			if (this.mostRecentInvoice.discount && this.mostRecentInvoice.discount.coupon) {
				return this.mostRecentInvoice.discount.coupon.id;
			}
		}
		else if (this.stripeCharge && this.stripeCharge.metadata) {
			return this.stripeCharge.metadata.couponCode;
		}
	}
	
  , getCouponAmount: function() {
		//NOTE: This does not handle percentage-off discounts (which we're not using, at least not at the time of this writing)
		
		if (this.mostRecentInvoice) {
			if (this.mostRecentInvoice.discount && this.mostRecentInvoice.discount.coupon) {
				return this.mostRecentInvoice.discount.coupon.amount_off / 100;
			}
		}
		else if (this.stripeCharge) {
			if (this.stripeCharge.metadata && this.stripeCharge.metadata.totalBeforeCoupon) {
				return (parseInt(this.stripeCharge.metadata.totalBeforeCoupon) - this.stripeCharge.amount) / 100;
			}
		}
	}
	
  , isTrial: function() {
		switch (this.planId) {
			case 'institutionalTrialIndividual':
			case 'institutionalTrialCampus':
				return true;
			default:
				return false;
		}
	}

	/*
  , getRememberCardInfo: function() {
        //TODO
        //We should probably set rememberCardInfo to true when creating automatically renewed
        //subscriptions as well; otherwise it's potentially confusing to have a public property
        //called rememberCardInfo that could return something different than this method.

        if (this.automaticRenewal) {
            return true;
        }
        //note that (at the time of this writing)
        //the rememberCardInfo property is only set for manual renewal;
        //with automatic renewal the card info is obviously always saved
        return (this.rememberCardInfo == true);
    }
    */
};

Subscription.fromJSON = function(json) {
	return new Subscription(json);
};

Subscription.getAvailablePlans = function() {
	return [
        {id:'yearly', name:'Yearly'},
		{id:'yearly-academic', name:'Yearly (Academic Discount)'},
		//special academic discount is more deeply discounted, for students/teachers at universities that have an institutional subscription
		{id:'yearly-academic-special', name:'Yearly (Special Academic Discount)'},
        {id:'monthly', name:'Monthly'},
        {id:'group-5-10', name:'Group 5-10'},
        {id:'group-11-20', name:'Group 11-20'},
        {id:'group-21+', name:'Group 21+'},
        {id:'institutionalTrialIndividual', name:'Institutional Free Trial - individual'},
		{id:'institutionalTrialCampus', name:'Institutional Free Trial - institution-wide'},
        {id:'custom-dates', name:'Custom Dates - No Reminder Email'}
    ];
}

Subscription.institutionalPlanTypes = [
	'singleLimitedAccount',
	'singleFullAccount',
	'onCampusOnly_loginRequired',
	'multipleAccounts'
];